import React, { useEffect } from 'react';
import { EngagementSpotlight } from '@atlassiansox/engagekit-ts';
import { SpotlightManager, SpotlightTarget } from '@atlaskit/onboarding';
import {
	useAnalyticsEvents,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { useQueryParam } from '@atlassian/jira-software-router-utils';
import type { IssueLinksMoreMenuSpotlightNudgeProps } from './types';

const ISSUE_LINKS_MORE_MENU_NUDGE_ID = 'issueLinksMoreMenuNudgeId';

export const IssueLinksNudgeSpotlight = ({ children }: IssueLinksMoreMenuSpotlightNudgeProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [selectedIssue] = useQueryParam('selectedIssue');
	useEffect(() => {
		if (!selectedIssue) {
			fireOperationalAnalytics(createAnalyticsEvent({}), 'spotlightContext loaded', {
				actionSubjectId: 'issueLinksOnJWMBoardMoreMenuNudge',
			});
		}
	}, [createAnalyticsEvent, selectedIssue]);

	return (
		<SpotlightManager>
			<SpotlightTarget name={ISSUE_LINKS_MORE_MENU_NUDGE_ID}>{children}</SpotlightTarget>
			<EngagementSpotlight engagementId={ISSUE_LINKS_MORE_MENU_NUDGE_ID} />
		</SpotlightManager>
	);
};
